import Fuse from "fuse.js";

import type {
    FormattedValue,
    FundExplorerDataIndexed,
    TopLevelDataObj,
} from "./types";

export type SearchData = { id: string } & Record<string, FormattedValue>;

export function createFuzzySearch(
    keys: string[],
    data: FundExplorerDataIndexed,
    minMatchCharLength = 3,
) {
    const options = {
        distance: 100,
        includeScore: true,
        includeMatches: true,
        minMatchCharLength,
        threshold: 0.3,
        useExtendedSearch: true,
        ignoreLocation: true,
        keys,
    };
    const list: SearchData[] = indexedDataToSearchList(data);
    const fuse = new Fuse(list, options);

    return (keywords: string | Fuse.Expression) =>
        fuse
            .search(keywords)
            .map(({ item: { id }, matches }) => ({ id, matches }));
}

export function indexedDataToSearchList(
    data: FundExplorerDataIndexed,
): SearchData[] {
    return Object.entries<TopLevelDataObj>(data).map(
        ([id, obj]) =>
            ({
                id,
                ...obj.data,
            }) as SearchData,
    );
}
